import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import {Component, OnInit, Output, EventEmitter, Input, ElementRef, HostListener} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import moment from "moment";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-people-profile-edit-details-modal',
  templateUrl: './people-profile-edit-details-modal.component.pug',
  styleUrls: ['./people-profile-edit-details-modal.component.scss'],
  standalone: false
})
export class PeopleProfileEditDetailsModalComponent implements OnInit {
  details: any;
  profile: any;
  snapstate: any;
  doNotContact: any;
  @Output() saveClick: EventEmitter<any> = new EventEmitter();
  profile_statuses = [
    {
      'label': $localize`Candidate`,
      'value': 3,
    },
    {
      'label': $localize`Employee`,
      'value': 1,
    },
    {
      'label': $localize`Ex-employee`,
      'value': 0,
    },
    {
      'label': $localize`Unspecified`,
      'value': 5,
    }
  ];
  saveButtonText = $localize`Save`
  cancelButtonText = $localize`Cancel`
  new_profile_statuses = [
    ...this.profile_statuses
    .filter(status => status.value !== 5)
    .map((status) => {
      return { key: status.value, value: status.label };
    })
  ]
  rehire_statuses = [
    {
      'label': $localize`Target`,
      'value': 0,
    },
    {
      'label': $localize`Potential target`,
      'value': 1,
    },
    {
      'label': $localize`No target`,
      'value': 2,
    },
    {
      'label': $localize`Unknown`,
      'value': 3,
    },
  ];

  new_rehire_statuses = [
    ...this.rehire_statuses.map((status) => {
      return { key: status.value, value: status.label };
    })
  ]

  editBody: any;
  status_label = '';
  rehire_status_label = '';
  department_label = '';
  selectedTab: any = 'all';
  domains: any;
  departments: any;
  valid_work_email = false;
  datepicker = false;
  config = { showWeekNumbers: false, dateInputFormat: moment.localeData().longDateFormat('L') };
  selectedStartDate: any;
  selectedEndDate : any;
  activeDateSelector = '';
  snapFields: any;
  enableSave = false;
  errors = {
    message: $localize `Invalid linkedin`,
    invalid: false,
    domain: $localize`*Domain is required`,
    domainError: false,
    email: $localize`*Email is required`,
    emailError: false,
    work: $localize`*Work email is invalid`,
    workError: false,
  }
  initialValues: any;
  initialDomain: string = '';

  workEmailErrors = [
    {'name': 'workError', 'msg': $localize`Work email is invalid`, 'enabled': false},
    {'name': 'emailError', 'msg': $localize`Email is required`, 'enabled': false},
    {'name': 'workEmailError', 'msg': $localize`Work email address is required`, 'enabled': false},
    {'name': 'emailInvalidError', 'msg': $localize`Email is invalid or blank`, 'enabled': false},
    {'name': 'domainError', 'msg': $localize`Domain is required`, 'enabled': false},
    {'name': 'domainInvalidError', 'msg': $localize`Domain is invalid`, 'enabled': false}
  ]
  personalEmailErrors = [
    {'name': 'emailError', 'msg': $localize`Email is required`, 'enabled': false},
    {'name': 'personalEmailError', 'msg': $localize`Personal email address is required`, 'enabled': false},
    {'name': 'emailInvalidError', 'msg': $localize`Email is invalid or blank`, 'enabled': false},
  ]
  linkedInErrors = [
    {'name': 'invalidError', 'msg': $localize`Not a valid LinkedIn URL. Please review and edit.`, 'enabled': false},
  ]

  readonly STATUS_EX_EMPLOYEE = $localize`Ex-employee`;
  readonly STATUS_EMPLOYEE = $localize`Employee`;
  readonly STATUS_CANDIDATE = $localize`Candidate`;
  readonly STATUS_POTENTIAL_CANDIDATE = $localize`Potential Candidate`;
  readonly STATUS_CHECK_RECIPIENT = $localize`Check recipient`;

  constructor(
    public bsModalRef: BsModalRef,
    public permissionService: PermissionsService,
    private permissions: PermissionsService
  ) { }

  ngOnInit(): void {
    this.profile_statuses[3] = {...this.profile_statuses[3], label : $localize`Check recipient`};

    this.editBody = {
      'first_name': '',
      'last_name': '',
      'work_email': '',
      'email': '',
      'mobile': '',
      'linkedin_profile': '',
      'status': 0,
      'rehire_status': 3,
      'department': '',
      'preferred_role': '',
      'job_title': '',
      'location': '',
      'employment_start_date': '',
      'employment_end_date': '',
      'org_department': 0,
    }
    if (this.snapstate?.person_details?.employment_start_date != null) {
      this.selectedStartDate = moment(this.snapstate?.person_details?.employment_start_date).format('ll');
    }
    if (this.snapstate?.person_details?.employment_end_date != null) {
      this.selectedEndDate = moment(this.snapstate?.person_details?.employment_end_date).format('ll');
    }

    this.status_label = this.profile['status'];
    this.rehire_status_label = this.profile['rehire_status'];
    this.department_label = this.profile['department'];
    const rehire_status = this.rehire_statuses.find(e => e.label == this.rehire_status_label);
    this.editBody['rehire_status'] = rehire_status ? rehire_status['value'] : 0;
    this.editBody['rehire_status'] = rehire_status ? rehire_status['value'] : 3;
    if (!this.profile_statuses.some(s => s.value === 4)) {
      this.profile_statuses.push({
        label: this.STATUS_POTENTIAL_CANDIDATE,
        value: 4,
      });
      this.editBody['organisation_name'] = this.profile.organisation_name;
      this.editBody['job_title'] = this.profile.job_title;
      this.filterProfileStatuses();
    }
    const status = this.profile_statuses.find(e => e.label == this.status_label);
    this.editBody['status'] = status ? status['value'] : 0;
    this.editBody['department'] = this.profile['department'];
    this.editBody['preferred_role'] = this.profile['preferred_role'];
    this.editBody['job_title'] = this.profile['job_title'];
    this.editBody['location'] = this.details['location'];
    this.editBody['first_name'] = this.details['first_name'];
    this.editBody['last_name'] = this.details['last_name'];
    this.editBody['work_email'] = this.getWorkEmail();
    this.editBody['email'] = this.getPersonalEmail(this.details);
    this.editBody['mobile'] = this.details['mobile'];
    this.editBody['linkedin_profile'] = this.details['linkedin_profile'];
    this.editBody['org_department'] = this.profile['org_department'];
    this.editBody['employment_start_date'] = this.details['employment_start_date'];
    this.editBody['employment_end_date'] = this.details['employment_end_date'];
    this.selectedTab = localStorage.getItem('people-page-selected-tab');
    this.snapFields = ConstantsService.NEW_PROFILE_FIELDS[this.status_label.toLowerCase()]
    this.enableSave = false;
    this.initialValues = JSON.parse(JSON.stringify(this.editBody));
  }

  hasChanges(): boolean {
    if (this.hasErrors()) {
      return false;
    }

    // Compare current values to initial values
    for (const key in this.editBody) {
      const initialValue = this.initialValues[key];
      const currentValue = this.editBody[key];

      // Special handling for empty/null values
      if ((initialValue === null || initialValue === undefined || initialValue === '') &&
        (currentValue === null || currentValue === undefined || currentValue === '')) {
        // Both values are effectively empty, so no change
        continue;
      }

      // Handle date fields
      if (key === 'employment_start_date' || key === 'employment_end_date') {
        const initialDate = initialValue ? moment(initialValue).format('YYYY-MM-DD') : '';
        const currentDate = currentValue ? moment(currentValue).format('YYYY-MM-DD') : '';
        if (initialDate !== currentDate) {
          return true;
        }
      }

      // Handle numeric fields that might be converted to strings (like org_department)
      if (key === 'org_department' || key === 'status' || key === 'rehire_status') {
        // Convert to strings for comparison to handle number vs string issues
        if (String(initialValue) !== String(currentValue)) {
          return true;
        }
        continue;
      }

      // Regular field comparison
      else if (currentValue !== initialValue) {
        return true;
      }
    }
    return false;
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  changeStatus(status) {
    this.status_label=status.label;
    this.editBody['status'] = status.value;
  }

  changeRehireStatus(rehireStatus) {
    this.rehire_status_label = rehireStatus.label;
    this.editBody['rehire_status'] = rehireStatus.value;
  }

saveProfile() {
    if (!this.hasChanges()) return;
    if (!this.validateProfileStatusAndDates(this.editBody)) return;
    if (!this.validateAtLeastOneContact(this.editBody)) return;

    this.validateEmailFields();
    if (this.hasErrors()) {
      return;
    }

    if (!this.validateFormFields()) {
      return;
    }

    let emails_with_types = new Object();
    emails_with_types = {
      personal: this.editBody.email,
      work: this.editBody.work_email,
    }

    let Fields = new Array();
    this.snapFields?.map((field) => {
      Fields.push(field.key)
    })
    for (let key in this.editBody) {
      if (!Fields.includes(key) || (!this.editBody[key] && this.editBody[key] != 0)) {
        delete this.editBody[key];
      }
    }

    for (let propName in this.editBody) {
      if(propName != 'status' && propName != 'rehire_status' && this.editBody[propName]){
        try {
          this.editBody[propName]=this.editBody[propName].trim();
        }
        catch (e) {
        }
      }
      if (this.editBody[propName] === null || this.editBody[propName] === undefined) {
        this.editBody[propName] = '';
      }
    }
    this.saveClick.emit({ ...this.editBody, emails_with_types: emails_with_types });
    this.bsModalRef.hide();
  }
  deleteProfile(){
    this.bsModalRef.hide();
  }

  validateEmailFields() {
    this.resetErrors();
    this.validateAllEmails();
    this.validateFormFields();
  }

  validateFormFields() {
    const areNamesProvided = () => {
      return (
        this.editBody.first_name.trim() !== '' &&
        this.editBody.last_name.trim() !== ''
      );
    };

    const namesAreValid = areNamesProvided();
    this.enableSave = namesAreValid && this.hasChanges();

    return namesAreValid;
  }

  openDatePicker(initializer: any) {
      if (initializer.init === 'start') {
        this.activeDateSelector = 'start';
        this.datepicker = !this.datepicker;
      }
      else if (initializer.init === 'end') {
        this.activeDateSelector = 'end';
        this.datepicker = true;
      }
}
  @HostListener('document:click', ['$event'])
  onClickOutsideDatePicker(event: MouseEvent) {
    const startdatepickerButton = document.getElementById('startDatepickerButton');
    const enddatepickerButton = document.getElementById('endDatepickerButton');
    if (startdatepickerButton && event.target !== startdatepickerButton && !startdatepickerButton.contains(event.target as HTMLElement)) {
      this.datepicker = false;
      if (enddatepickerButton && event.target == enddatepickerButton && enddatepickerButton.contains(event.target as HTMLElement) ){
        this.datepicker = true;
      }
    }

  }

  onDateSelect(date: any) {
    if (this.activeDateSelector == 'start') {
      this.selectedStartDate = moment(date).format('ll');
      this.editBody['employment_start_date'] = moment(date).format('YYYY-MM-DD');
    }
    else if (this.activeDateSelector == 'end') {
      this.selectedEndDate = moment(date).format('ll');
      this.editBody['employment_end_date'] = moment(date).format('YYYY-MM-DD');
    }
    this.datepicker = !this.datepicker;
    this.enableSave = this.hasChanges() && this.validateProfileStatusAndDates(this.editBody) && this.validateAtLeastOneContact(this.editBody);
  }
  isValidLinkedInProfile(url) {
    const pattern = /^(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/[a-z0-9_-]+\/?$/i;
    return pattern.test(url);
  }

  getWorkEmail() {
    return this.snapstate?.person_details?.emails_with_types?.work || ''
  }

  getPersonalEmail(details): any {
    if (details?.emails_with_types?.personal) {
      return details?.emails_with_types.personal;
    }
    else return '';
  }

  handleBodyChange(_event: any) {
    if (_event.field) {
      if (['status','rehire_status','org_department'].includes(_event.field)) {
        this.editBody[_event.field] = _event.event.key;

        if (_event.field == 'status') {
          //@ts-ignore
          this.status_label = this.profile_statuses.find(e => e.value == this.editBody['status'])?.label
          this.filterProfileStatuses();
          this.snapFields = ConstantsService.NEW_PROFILE_FIELDS[this.status_label.toLowerCase()]

          //@ts-ignore
          this.rehire_status_label = this.rehire_statuses.find(e => e.value == this.editBody['rehire_status'])?.label
        }
      }
    }
    this.BodyChange();
  }
  validateProfileStatusAndDates(data): any {
    if (!this.hasChanges()) {
      return false;
    }

    if (!this.validateFormFields()) {
      return false;
    }

    if (this.validateAllEmails()) {
      return false;
    }

    if (data.status == 0) {

      // Disable save if end_date < start_date
      if (data.employment_end_date && data.employment_start_date)
      {
        if (moment(data.employment_end_date) < moment(data.employment_start_date))
        {
          return false;
        }
      } else if (!data.employment_end_date && data.employment_start_date) {
        // If employment_end_date is null, it is treated as today's date in case of ex-employee
        if (moment().isBefore(moment(data.employment_start_date))) {
          return false;
        }
      }
    }
    return true;
  }

  validateAtLeastOneContact(data): boolean {

    const hasMobile = data.mobile &&
      data.mobile !== '' &&
      data.mobile !== null &&
      data.mobile !== undefined &&
      data.mobile !== '+' &&
      data.mobile.length > 3;

    const hasEmail = data.email &&
      data.email !== '' &&
      data.email !== null &&
      data.email !== undefined;

    const hasWorkEmail = data.work_email &&
      data.work_email !== '' &&
      data.work_email !== null &&
      data.work_email !== undefined;

    return hasMobile || hasEmail || hasWorkEmail;
  }


  validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  validateExEmployeeEmail(email) {
    const regex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  }
  validateAllEmails() {
    //linkedin field validation
    if (this.editBody.linkedin_profile != '' && this.editBody.linkedin_profile != null) {
      this.setLinkedInError(
        'invalidError',
        !this.isValidLinkedInProfile(this.editBody.linkedin_profile)
      );
    } else { this.setLinkedInError('invalidError', false); }


    if (!this.validateEmail(this.editBody.email) && this.editBody.email) {
      this.setPersonalEmailError('emailInvalidError', true)
    }

    if (this.editBody.work_email && !this.validateEmail(this.editBody.work_email)) {
      this.setWorkEmailError('emailInvalidError', true)
    }

    if (this.hasErrors()) {
      return true;
    }
    return false;
  }

  BodyChange() {
    this.resetErrors();
    this.enableSave = this.hasChanges() && this.validateProfileStatusAndDates(this.editBody) && this.validateAtLeastOneContact(this.editBody);
  }

  LocationChange() {
    this.resetErrors();
    this.enableSave = this.hasChanges() && this.validateProfileStatusAndDates(this.editBody) && this.validateAtLeastOneContact(this.editBody);
    if (!this.editBody.location) {
      this.editBody.location = '';
    }
  }

  setWorkEmailError(name: string, enabled: boolean) {
    this.workEmailErrors.find(o => o.name === name)!.enabled = enabled;
    this.workEmailErrors = [...this.workEmailErrors];
  }
  setLinkedInError(name: string, enabled: boolean) {
    this.linkedInErrors.find(o => o.name === name)!.enabled = enabled;
    this.linkedInErrors = [...this.linkedInErrors];
  }
  setPersonalEmailError(name: string, enabled: boolean) {
    this.personalEmailErrors.find(o => o.name === name)!.enabled = enabled;
    this.personalEmailErrors = [...this.personalEmailErrors];
  }

  hasErrors() {
    if (this.workEmailErrors.find(e => e.enabled)) return true;
    if (this.personalEmailErrors.find(e => e.enabled)) return true;
    if (this.linkedInErrors.find(e => e.enabled)) return true;
    return false;
  }

  resetErrors() {
    this.setLinkedInError('invalidError', false);
    this.setWorkEmailError('emailError', false);
    this.setWorkEmailError('emailInvalidError', false);
    this.setWorkEmailError('domainError', false);
    this.setWorkEmailError('domainInvalidError', false);
    this.setPersonalEmailError('emailError', false);
    this.setPersonalEmailError('emailInvalidError', false);
    this.setWorkEmailError('workEmailError', false)
    this.setPersonalEmailError('personalEmailError', false)
  }

  phoneUpdate(event) {
    this.editBody['mobile'] = event['phone'].includes('null') ? '' : event['phone'];
    this.enableSave = this.hasChanges() && this.validateProfileStatusAndDates(this.editBody) && this.validateAtLeastOneContact(this.editBody);
  }

  filterProfileStatuses() {
    const currentStatus = this.editBody['status'];
    const actualStatus = this.profile.status;

    if ([0, 1, 3].includes(currentStatus)) {
      // Determine which statuses to exclude based on actualStatus
      let statusesToExclude: number[] = []; // Explicitly type as number[]

      // Include "Potential Candidate" (4) only if actualStatus is "Potential Candidate"
      if (actualStatus !== 'Potential Candidate') {
        statusesToExclude.push(4);
      }

      // Include "Check recipient/Unspecified" (5) only if actualStatus is "Check recipient"
      if (actualStatus !== 'Check recipient') {
        statusesToExclude.push(5);
      }

      this.new_profile_statuses = this.profile_statuses
        .filter(status => !statusesToExclude.includes(status.value))
        .map((status) => {
          return {key: status.value, value: status.label};
        });
    } else if (currentStatus === 5) {
      // If "Check recipient" is selected, show "Employee", "Ex-employee", "Candidate" and "Check recipient"
      this.new_profile_statuses = this.profile_statuses
        .filter(status => [0, 1, 3, 5].includes(status.value))
        .map((status) => {
          return {key: status.value, value: status.label};
        });
    } else if (currentStatus === 4) {
      // If "Potential Candidate" is selected, show "Employee", "Ex-employee", "Candidate" and "Potential Candidate"
      this.new_profile_statuses = this.profile_statuses
        .filter(status => [0, 1, 3, 4].includes(status.value))
        .map((status) => {
          return {key: status.value, value: status.label};
        });
    } else {
      // Default case - show all statuses except "Check recipient" (as per your existing logic)
      this.new_profile_statuses = this.profile_statuses
        .filter(status => status.value !== 5)
        .map((status) => {
          return {key: status.value, value: status.label};
        });
    }
}

}
